<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row"  v-if="userData.permissions['patient_triage']==1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="AddPatient">
              <div class="row">
                <div class="col-lg-4">
                    <div class="form-group mb-2">
                    <label>Patient's Name</label>
                      <multiselect v-model="patient" @input="FilterPatient" :options="patients" :custom-label="customLabel" label="name"></multiselect>
                    </div>
                    <div class="form-group mb-2">
                      <label>Triage Date</label>
                      <input v-model="triagedate" type="date" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Telephone</label>
                      <b-input-group prepend="+256"><input v-model="telephone" readonly  type="text" class="form-control"/></b-input-group>
                    </div>                  
                    <div class="form-group mb-2">
                      <label>Gender</label>
                      <input v-model="gender" readonly type="text" class="form-control" />
                    </div>
                    <div class="form-group mb-2">
                      <label>Address</label>
                      <input v-model="address" readonly type="text" class="form-control" />
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-group mb-2">
                      <b-form-group label="Temperature ( ℃ )" description="Patient's Temperature">
                      <input v-model="temperature" type="text" class="form-control" />
                      </b-form-group>
                    </div>  
                    <div class="form-group mb-2">
                      <b-form-group label="Weight (Kgs)" description="Patient's Weight">
                      <input v-model="weight" type="text" class="form-control" />
                      </b-form-group>
                    </div>  
                    <div class="form-group mb-2">
                      <b-form-group label="Height (cm)" description="Patient's Height">
                      <input v-model="height"  type="text" class="form-control" />
                      </b-form-group>
                    </div>
                    <div class="form-group mb-2">
                      <b-form-group label="MUAC (cm)" description="Mid Upper Arm Circumference">
                      <input v-model="muac" type="text"  class="form-control"/>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="form-group mb-2">
                      <b-form-group label="Blood Pressure(mmHg)" description="Blood Pressure">
                      <input v-model="bloodpressure"  type="text" class="form-control" />
                      </b-form-group>
                    </div>
                    <div class="form-group mb-2">
                      <b-form-group label="Pulse (b/min)" description="Heart Rate and Pulse">
                      <input v-model="pulse"  type="text" class="form-control" />
                      </b-form-group>
                    </div>
                    <div class="form-group mb-2">
                      <b-form-group label="Oxygen Rate (%)" description="SpO2">
                      <input v-model="oxygenrate" type="text" class="form-control" />
                      </b-form-group>
                    </div>
                    <div class="form-group mb-2">
                      <label>Turn around time</label>
                      <b-form-select class="form-control" v-model="turnaroundtime">
                        <option value="1">Waiting</option>
                        <option value="2">Emergency</option>
                      </b-form-select>
                    </div>
                    <div class="form-group"><br>
                    <b-button type="submit" class="btn w-100" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
                    </div>
                  </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Patient`s Triage</span></center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import { patientMethods, patientComputed } from "@/state/helpers";

export default {
  page: {
    title: "Patient Triage",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    Multiselect,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Triage",
      items: [{text: "Dashboard",href: "/"},{text: "Patients",active: true}],
      services:[],
      patient: "",
      telephone:'',
      gender:'',
      address:'',
      triagedate: new Date().toLocaleDateString('fr-CA'),
      weight: "",
      muac: "",
      height: "",
      bloodpressure: "",
      temperature: "",
      pulse: "",
      oxygenrate: "",
      turnaroundtime:'1'
    };
  },
  methods: {
    ...patientMethods,
      customLabel ({ name, address }) {
        return `${name} - ${address}`
      },
    async FilterPatient(){
      let url = `/findpatient/${this.patient.patient_id}`;
        await axios.get(url).then((response) => {
        if (response.data.patients) {
          this.telephone = response.data.patients[0].telephone;
          this.address = response.data.patients[0].address;
          this.gender = response.data.patients[0].gender;
        }});
    },
    async AddPatient() { 
        let formData = new FormData();
        formData.append("patient", this.patient.patient_id);
        formData.append("triagedate", this.triagedate);
        formData.append("temperature", this.temperature);
        formData.append("weight", this.weight);
        formData.append("height", this.height);
        formData.append("muac", this.muac);
        formData.append("bloodpressure", this.bloodpressure);
        formData.append("pulse", this.pulse);
        formData.append("oxygenrate", this.oxygenrate);
        formData.append("turnaroundtime", this.turnaroundtime);
        let url = "/addtraiage";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPatients();
            this.$bvModal.hide('new-unit');
            this.patient="";
            this.telephone="";
            this.height="";
            this.weight="";
            this.temperature="";
            this.muac="";
            this.bloodpressure="";
            this.gender="";
            this.address="";
            this.pulse="";
            this.oxygenrate="";
            this.$toast.success(response.data.message);
        }
        });
      },
  },
  computed: {
    ...patientComputed,
  },
  mounted() {
    this.fetchPatients();
  },
};
</script>